export default "__VITE_ASSET__Cd8lpj6p__"